var map = {
	"./back.svg": "c557",
	"./butten_right.svg": "39d1",
	"./logo_关于艾佳德.svg": "cd5f",
	"./logo_艾佳德.svg": "8208",
	"./menu.svg": "bd3d",
	"./shouqi.svg": "6d25",
	"./zhankai.svg": "4be4",
	"./中国心理卫生协会logo.svg": "d400",
	"./底部导航_logo.svg": "30b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e81";